import React, { forwardRef } from 'react';

import type { FilterPopoverProps } from '@vlabs/monokit/shared/ui/popovers/filter-popover';
import { FilterPopover } from '@vlabs/monokit/shared/ui/popovers/filter-popover';
import validate from '@vlabs/shared/validators';
import { Control } from '@vlabs/uikit';
import { useFormContext } from 'react-hook-form';

import { useSearchPageTranslation } from '../../../../i18n';
import st from '../popovers.module.sass';

function SimilarityFilterPopover(
  {
    ...props
  }: FilterPopoverProps<string>,
  ref: React.ForwardedRef<HTMLDivElement>,
) {
  const { t } = useSearchPageTranslation();
  const { register, formState: { errors }, setValue } = useFormContext();

  return (
    <FilterPopover
      {...props}
      name="threshold"
      ref={ref}
      title={<div className="Body-2">{t('filters.common.similarity_percent')}</div>}
    >
      <Control.Input
        id="threshold"
        placeholder={t('filters.common.from')}
        {...register('threshold', {
          min: validate.gte(0),
          max: validate.lte(100),
          validate: validate.number(),
        })}
        errors={errors}
        isClearable
        onClear={() => setValue('threshold', '')}
      />
      <div className={st.Divider} />
    </FilterPopover>
  );
}

const SimilarityFilterPopoverWithRef = forwardRef(SimilarityFilterPopover);
export { SimilarityFilterPopoverWithRef as SimilarityFilterPopover };
